/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'

import { Divider, ListItem as MaterialListItem, FontIcon, IconButton } from 'material-ui'
import { ListItem } from 'generic/list'

import * as constants from 'constants/Prestation'

class HistoryPanel extends React.Component {
  render () {
    const iconValidationSentStep = [
      constants.TO_VALIDATE_PRESTATION_STATUS,
      constants.VALIDATED_PRESTATION_STATUS,
      constants.PAID_PRESTATION_STATUS,
      constants.INVOICED_PRESTATION_STATUS,
      constants.TO_VERIFY_PRESTATION_STATUS,
      constants.CLOSED_PRESTATION_STATUS,
    ]

    return (
      <React.Fragment>
        <Divider/>

        <MaterialListItem
          primaryText={this.props.intl.formatMessage(constants.messages.PRESTATION_HISTORY_LABEL)}
          initiallyOpen={false}
          primaryTogglesNestedList={true}
          nestedItems={
            this.props.histories.map((history, index) => {
              const historyMoment = moment(history.datetime, 'YYYY-MM-DD HH:mm:ss')

              return (
                <ListItem
                  disabled={true}
                  key={index}
                  primaryText={
                    <div>
                      <div className='inline middle' style={{marginRight: 5, fontSize: 15}}>
                        { history.user_display_name ? history.user_display_name + ' - ' : undefined } { historyMoment.format('DD.MM.YYYY HH:mm:ss') }
                      </div>
                        {
                          this.props.prestation.validation_token &&
                          (!this.props.prestation.validation_reminder_step ||
                           this.props.prestation.validation_reminder_step === constants.INTERPRETER_REMINDER_STEP) &&
                          iconValidationSentStep.indexOf(history.step_name) >= 0
                            ? <div className='inline middle' style={{marginRight: 5}}>
                              <IconButton
                                tooltip={this.props.intl.formatMessage(constants.messages.VALIDATION_DISTANCE_SENT)}
                                style={{margin: 0, padding: 0, height: 23}}
                              >
                                <FontIcon
                                  className='material-icons inline middle'
                                >
                                  forward_to_inbox
                                </FontIcon>
                              </IconButton>
                            </div>
                            : null
                        }

                        {
                          history.comment
                          ? <div style={styles.button}>
                            {history.comment}
                          </div>
                          : undefined
                        }
                    </div>
                  }
                  secondaryText={history.display_name}
                />
              )
            })
          }
        />
      </React.Fragment>
    )
  }
}

const styles = {
    button: {
        marginRight: 5,
        fontStyle: 'italic',
        fontSize: 14,
        height: 'auto',
        overflow: 'visible',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
  }
}

export default injectIntl(HistoryPanel)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/HistoryPanel.js